// removed by extract-text-webpack-plugin
module.exports = {"distanceText":"distanceText__c9TBt","panel":"panel__4LPFw","loading":"loading__1cQ0m","overflowPanel":"overflowPanel__17dA6"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Network/coms/CapacityView/styles.scss
// module id = 2285
// module chunks = 1